export default __webpack_public_path__ + "static/media/gplay-logo.82480ecf.svg";